import { ArrowUpRightIcon } from '@mote/assets/icons'
import { Button, Link } from '@mote/ui'
import { useMoteConversationContext } from '../mote'

export interface StickyButtonProps {
  hideTitle: boolean
}

export const StickyButton = (props: StickyButtonProps): JSX.Element => {
  const moteConversationContext = useMoteConversationContext()

  if (!moteConversationContext.hasData) {
    return <></>
  }

  if (!moteConversationContext.getIsStickyMote()) {
    return <></>
  }

  const moteStatus = moteConversationContext.getMoteStatus()
  const innerText = props.hideTitle ? undefined : moteStatus.containingURLTitle

  return (
    <Button
      //@ts-expect-error
      as={Link}
      icon={<ArrowUpRightIcon />}
      to={moteStatus.containingURL}
      text={innerText}
      variant='secondary'
      size='xs'
      target='_blank'
      title={moteStatus.containingURLTitle}
      data-testid='sticky-mote-button'
    />
  )
}
